import { render, staticRenderFns } from "./LandingPageBody.vue?vue&type=template&id=25bfdf37&scoped=true&"
import script from "./LandingPageBody.vue?vue&type=script&lang=js&"
export * from "./LandingPageBody.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageBody.vue?vue&type=style&index=0&id=25bfdf37&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfdf37",
  null
  
)

export default component.exports